import { PartyService } from 'src/app/services/api/party/party.service';
import { Party } from '../../../models/party-manager/party';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/core/header-menu/loader/loader.service';
import { CoverageService, G37Response } from 'src/app/services/api/coverage/coverage.service';
import { FtthService } from 'src/app/services/api/ftth/ftth.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { OrderService } from 'src/app/services/api/orders/specific-order/order.service';
import { ActionsProductSpec, ProductService } from 'src/app/services/api/product/product.service';
import { TemplatesService } from 'src/app/services/api/templates/templates.service';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';

import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { combineLatest, from, iif, Observable, of, Subscription, zip } from 'rxjs';
import { catchError, concatMap, debounceTime, distinctUntilChanged, filter, map, retry, startWith, switchMap, toArray } from 'rxjs/operators';
import { generateExternalID } from '../../../models/order/order.model';
import { CatalogService } from '../../../services/api/catalog/catalog.service';
import { KeycloakService } from 'keycloak-angular';
import { Role } from 'src/app/utils/Role';
import { ProductContainer } from 'src/app/models/interface/product/product.model';

class Street {
  street: string;

  constructor(
    public id: string,
    public fullStreet: string,
    public postalCode: string,
    public population: string,
    public province: string,
    public type: 'G12' | 'G17',
  ) {
    this.street = fullStreet.split(',')[0].trim();
  }
}

class StreetNumber {
  constructor(
    public id: string,
    public streetNumber: string,
  ) {
  }
}

@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss']
})
export class NewProductComponent implements OnInit, OnDestroy {

  loading: boolean;
  saving: boolean;

  specIdForm: FormGroup;
  homeForm: FormGroup;
  form: FormGroup;
  vlanForm: FormGroup;

  specIds: ActionsProductSpec[];
  parties: Party[];

  combos = {
    template: [],
  };

  userRoles: string[];
  allRoles: any;

  isAdmin: boolean;
  firstEditExternalId: boolean;

  streets: Street[];
  streetNumbers: StreetNumber[];
  places: G37Response[];

  private catchErrorOnObservable = catchError<any, Observable<any[]>>(error => {
    console.error(error);
    return of([]);
  });
  private subscriptions = new Subscription();

  constructor(
    private coverageService: CoverageService,
    private breadcrumbsService: BreadcrumbsService,
    private productService: ProductService,
    private templatesService: TemplatesService,
    private ftthService: FtthService,
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private notificationsService: NotificationsService,
    private router: Router,
    private partyService: PartyService,

    private keycloakService: KeycloakService
  ) {

  }

  ngOnInit() {
    this.specIds = [];
    this.firstEditExternalId = true;
    this.saving = false;

    // Workaround (no tenemos varios ISPs por ahora) --> Podemos crear en KC el rol "Admin".

    //Echar un ojo a templates + acciones. Cargar en NgModule los pop-ups y cargar horas en templates.
    this.userRoles = this.keycloakService.getUserRoles();
    this.allRoles = Role;

    if (this.userRoles.includes(Role.Admin)) {
      this.isAdmin = true;
    }
    else {
      this.isAdmin = false;
    }

    //this.isAdmin = this.authService.isAdmin;

    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: 'Productos', url: 'provision/products/search' },
            { title: 'Reserva de producto', url: 'provision/products/new' }
          ]
      }
    );

    this.initSpecIdForm();

    this.subscriptions.add(this.productService.getProductSpecs$().subscribe(specIds => this.specIds = specIds));
    this.subscriptions.add(this.loaderService.loading$.subscribe(loading => this.loading = loading));

    this.subscriptions.add(
      iif(
        () => this.isAdmin,
        this.partyService.getCustomers(),
        of<Party[]>()
      )/*
        .pipe(
          switchMap(isps => from(isps)
            .pipe(
              concatMap(isp => zip(of(isp), of(true))),
              filter(([_, isOrquestable]) => isOrquestable),
              map(([isp, _]) => isp),
            )),
          toArray(),
        )*/
        .pipe(
          switchMap(isps => from(isps)),
          toArray(),
        )
        .subscribe(parties => {
          this.parties = parties.sort((a,b) => a.name.localeCompare(b.name));
          /*
          if (this.origins.length === 0 ) {
            this.origins.push({name: 'Adamo', code: '837'});
          }
          */
          //this.ispControl.setValue(this.origins[0]);
        }));

    this.initForm();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private initSpecIdForm() {
    this.specIdForm = this.formBuilder.group({
      specId: this.formBuilder.control('', Validators.required),
      isp: this.formBuilder.control('', Validators.required),
    });
  }

  private initForm() {

    /*
    if (this.isAdmin) {
      this.ispControl.setValue({name: 'Adamo', code: '837'});
    }
    */

    this.homeForm = this.formBuilder.group({
      street: this.formBuilder.control('', [Validators.required, Validators.minLength(3)]),
      number: this.formBuilder.control(''),
      block: this.formBuilder.control('', Validators.required),
    });

    this.form = this.formBuilder.group({
      iddomicilio: this.formBuilder.control('', Validators.required),
      template: this.formBuilder.control('', Validators.required),
      remoteid: this.formBuilder.control('', Validators.required),
      ppai: this.formBuilder.control('', Validators.required),
      tvremoteid: this.formBuilder.control('')
    });

    this.vlanForm = this.formBuilder.group({});

    this.subscriptions.add(
      /*combineLatest(
        this.specIdControl.valueChanges
          .pipe(
            startWith(this.specIdForm.value),
            filter(() => this.specIdControl.valid),
            map(() => this.specIdIsBusiness() ? 'EMP' : 'RES'),
          ),*/
      this.ispControl.valueChanges
        .pipe(
          startWith(this.ispControl.value),
          filter(() => this.ispControl.valid),
          //switchMap(([segment, isp]: ['EMP' | 'RES', Customer]) => this.templatesService.getTemplates(null, null, null, {/*segment,*/ isp: isp.name})),
          //map(data => data.content.filter(template => template.isActive)),
        )
        .subscribe(isp => {

          this.templatesService.getTemplates(null, '50', null, {/*segment,*/ isp: isp.namingId }, "").subscribe(
            (data) => {
              const templates = data.content.filter(template => template.isActive);
              this.combos.template = [];
              for (const template of templates) {
                this.combos.template.push(
                  {
                    template: template.value,
                    territoryOwner: '837',
                  }
                );
                /*
                for (const mapping of template.mappings) {
                  if (mapping.territoryUser === this.ispControl.value.name && !this.combos.template.includes(mapping.externalTemplateISP)) {
                    this.combos.template.push(
                      {
                        template: mapping.externalTemplateISP,
                        territoryOwner: mapping.territoryOwner.toLowerCase().replace(/[\s]/g, '')
                      }
                    );
                  }
                }
                */
              }
              /*
              if (this.combos.template.length === 0) {
                this.combos.template.push({
                  template: 'TEMPLATE_DE_EJEMPLO',
                  territoryOwner: '837',
                });
              }
              */
            })
        }));

    /*
  this.subscriptions.add(
    this.ispControl.valueChanges
      .pipe(
        startWith(this.ispControl.value),
        filter(() => this.ispControl.valid),
        switchMap(ispValue => this.productService.getIspProductSpecs$(ispValue.code)),
      )
      .subscribe(productSpecs => this.specIds = productSpecs));
        */

    this.subscriptions.add(
      combineLatest(
        this.streetControl.valueChanges
          .pipe(
            startWith(''),
            filter(() => this.streetControl.valid),
            filter(value => typeof value === 'string'),
            debounceTime(300),
            distinctUntilChanged(),
          ),
        this.ispControl.valueChanges
          .pipe(
            startWith(this.ispControl.value),
            filter(() => this.ispControl.valid),
          ),
      )
        .pipe(
          switchMap(([street, isp]: [string, Party]) => {
            const hasNumber = /\d/;
            if (hasNumber.test(street)) {
              return this.coverageService.getPlacesByG17(street, isp.name.toLowerCase().replace(/[\s]/g, ''))
                .pipe(
                  map(streets => streets.map(streetResponse => new Street(streetResponse.G17, streetResponse.direccionG17, streetResponse.Codigo_Postal, streetResponse.Poblacion, streetResponse.Provincia, 'G17'))),
                  this.catchErrorOnObservable,
                );
            }
            return this.coverageService.getPlacesByG12(street, isp.name.toLowerCase().replace(/[\s]/g, ''))
              .pipe(
                map(streets => streets.map(streetResponse => new Street(streetResponse.G12, streetResponse.direccionG12, streetResponse.Codigo_Postal, streetResponse.Poblacion, streetResponse.Provincia, 'G12'))),
                this.catchErrorOnObservable,
              );
          }),
        )
        .subscribe(streets => this.streets = streets));

    this.subscriptions.add(
      combineLatest(
        this.numberControl.valueChanges
          .pipe(
            startWith(''),
            filter(() => this.streetControl.valid && typeof this.streetControl.value !== 'string' && this.streetControl.value.type === 'G12'),
            filter(value => typeof value === 'string'),
            debounceTime(300),
            map(value => ({ streetNumber: value, streetG12: this.streetControl.value.id })),
          ),
        this.ispControl.valueChanges
          .pipe(
            startWith(this.ispControl.value),
            filter(() => this.ispControl.valid),
          )
      )
      .pipe(
        switchMap(([streetNumber, isp]: [any, Party]) => this.coverageService.getPlacesByG12AndNumber(streetNumber.streetG12, isp.name.toLowerCase().replace(/[\s]/g, ''), streetNumber.streetNumber)
          .pipe(
            this.catchErrorOnObservable,
          )),
        map(streetNumbers => streetNumbers.map(streetNumber => new StreetNumber(streetNumber.G17, streetNumber.Numero_translate))),
      )
      .subscribe(streetNumbers => {
        this.streetNumbers = streetNumbers;
        if (streetNumbers.length === 1) {
          this.numberControl.setValue(streetNumbers[0]);
          this.clearPlaces();
        }
      })
    );

    this.subscriptions.add(
      combineLatest(
        this.blockControl.valueChanges
          .pipe(
            startWith(''),
            filter(() => this.streetControl.valid && typeof this.streetControl.value !== 'string'),
            filter(value => typeof value === 'string'),
          ),
        this.ispControl.valueChanges
          .pipe(
            startWith(this.ispControl.value),
            filter(() => this.ispControl.valid),
          ),
      )
        .pipe(
          switchMap(([_, isp]: [any, Party]) => {
            if (this.streetControl.value.type === 'G17') {
              return this.coverageService.getG37PlacesBySelectedG17(this.streetControl.value.id, isp.name.toLowerCase().replace(/[\s]/g, ''))
                .pipe(
                  this.catchErrorOnObservable,
                );
            } else if (typeof this.numberControl.value !== 'string') {
              return this.coverageService.getG37PlacesBySelectedG17(this.numberControl.value.id, isp.name.toLowerCase().replace(/[\s]/g, ''))
                .pipe(
                  this.catchErrorOnObservable,
                );
            }
            return of([]);
          }),
        )
        .subscribe(places => {
          this.places = places;
          if (places.length === 1) {
            this.blockControl.setValue(places[0]);
            this.placeSelected();
          }
        }));
  }

  displayStreet(street?: Street): string | undefined {
    return street ? `${street.street} - ${street.population}, ${street.province}, ${street.postalCode}` : undefined;
  }

  streetSelected() {
    this.clearStreetNumbers();
    this.clearPlaces();
  }

  private clearStreetNumbers() {
    this.streetNumbers = [];
    this.numberControl.setValue('');
  }

  displayNumber(streetNumber?: StreetNumber): string | undefined {
    return streetNumber ? streetNumber.streetNumber : undefined;
  }

  numberSelected() {
    this.clearPlaces()
  }

  private clearPlaces() {
    this.places = [];
    this.blockControl.setValue('');
  }

  placeSelected() {
    this.coverageService.getInoIdsFromIdAndIsp(
      this.blockControl.value.ID_DOMICILIO_TO,
      this.ispControl.value.name.toLowerCase().replace(/[\s]/g, '')
    ).subscribe(
      (data) => {
        for (const template of this.combos.template) {
          if (Object.keys(data.inoIds)[0] !== template.territoryOwner) {
            this.combos.template.splice(this.combos.template.findIndex(templateAux => templateAux === template), 1);
          }
        }
        this.homeIdControl.setValue(this.blockControl.value.ID_DOMICILIO_TO);
      },
      (error) => {
        this.notificationsService.showNotification(
          'Ha habido un problema al obtener el INO más prioritario para el ISP',
          NotificationLevel.ERROR
        );
        return;
      }
    );
  }

  specIdIsBusiness(): boolean {
    return this.specIdControl.value ? this.specIdControl.value.productSpecName.includes('Business') : false;
  }

  specIdChange() {
    if (this.specIdIsBusiness()) {
      const validators = [Validators.min(0), Validators.pattern(/^-?\d+$/)];

      this.vlanForm.addControl('svlan', this.formBuilder.control('', [Validators.required, ...validators]));

      this.vlanForm.addControl('cvlan1', this.formBuilder.control('', [Validators.required, ...validators]));
      this.vlanForm.addControl('cvlan2', this.formBuilder.control('', validators));
      this.vlanForm.addControl('cvlan3', this.formBuilder.control('', validators));
      this.vlanForm.addControl('cvlan4', this.formBuilder.control('', validators));
      this.vlanForm.addControl('cvlan5', this.formBuilder.control('', validators));

      this.vlanForm.addControl('avlan1', this.formBuilder.control('', [Validators.required, ...validators]));
      this.vlanForm.addControl('avlan2', this.formBuilder.control('', validators));
      this.vlanForm.addControl('avlan3', this.formBuilder.control('', validators));
      this.vlanForm.addControl('avlan4', this.formBuilder.control('', validators));
      this.vlanForm.addControl('avlan5', this.formBuilder.control('', validators));
    } else {
      this.vlanForm.removeControl('svlan');

      this.vlanForm.removeControl('cvlan1');
      this.vlanForm.removeControl('cvlan2');
      this.vlanForm.removeControl('cvlan3');
      this.vlanForm.removeControl('cvlan4');
      this.vlanForm.removeControl('cvlan5');

      this.vlanForm.removeControl('avlan1');
      this.vlanForm.removeControl('avlan2');
      this.vlanForm.removeControl('avlan3');
      this.vlanForm.removeControl('avlan4');
      this.vlanForm.removeControl('avlan5');
    }
  }

  ispChange() {
    this.homeForm.reset();
    this.streetControl.setValue('');
    this.numberControl.setValue('');
    this.form.reset();
    this.vlanForm.reset();
  }

  templateIsTv(): boolean {
    if (this.templateControl.value && this.templateControl.value.includes('TV')) {
      this.tvRemoteIdControl.setValidators(Validators.required);
      return true;
    }
    else {
      this.tvRemoteIdControl.setValidators([]);
      return false;
    }
    return this.templateControl.value ? this.templateControl.value.includes('TV') : false;
  }

  /*
  templateChange() {
    if (this.templateIsTv()) {
      this.form.addControl('tvremoteid', this.formBuilder.control('', Validators.required));
    } else {
      this.form.removeControl('tvremoteid');
    }
  }
  */

  save() {
    this.vlanForm.markAllAsTouched();

    if (this.form.valid && this.vlanForm.valid && !this.loading && !this.saving) {
      this.saving = true;
      /*
      this.subscriptions.add(this.orderService.existsExternalId(generateExternalID())
        .pipe(
          retry(3),
          switchMap(externalId => {
      */
      const productContainer: ProductContainer = {
        operador: this.ispControl.value.namingId,
        iddomicilio: this.homeIdControl.value,
        template: this.templateControl.value,
        remoteid: this.remoteIdControl.value,
        ppai: this.ppaiControl.value,
        tvremoteid: this.tvRemoteIdControl.value ? this.tvRemoteIdControl.value : '',
        pid: ''
      };

      /*
      if (this.templateIsTv()) {
        productContainer.tvremoteid = this.tvRemoteIdControl.value;
      }
      */

      if (this.specIdIsBusiness()) {
        productContainer.svlan = this.svlanControl.value
        productContainer.avlan = {
          vlan1: this.avlan1Control.value,
          vlan2: this.avlan2Control.value ? this.avlan2Control.value : undefined,
          vlan3: this.avlan3Control.value ? this.avlan3Control.value : undefined,
          vlan4: this.avlan4Control.value ? this.avlan4Control.value : undefined,
          vlan5: this.avlan5Control.value ? this.avlan5Control.value : undefined,
        }
        productContainer.cvlan = {
          vlan1: this.cvlan1Control.value,
          vlan2: this.cvlan2Control.value ? this.cvlan2Control.value : undefined,
          vlan3: this.cvlan3Control.value ? this.cvlan3Control.value : undefined,
          vlan4: this.cvlan4Control.value ? this.cvlan4Control.value : undefined,
          vlan5: this.cvlan5Control.value ? this.cvlan5Control.value : undefined,
        }
      }

      return this.ftthService.reserve(productContainer)
        .subscribe(
          (data) => {
            const idadministrativo = data.idadministrativo;
            this.saving = false;
            if (data && data.resultado !== 'NOK' && data.resultado !== 'KO') {
              this.router.navigate(['/provision/products/search'], { queryParams: { idadministrativo } });
            }
            else {
              this.notificationsService.showNotification("ERROR (" + data.codResultado + "): " + data.descResultado, NotificationLevel.ERROR);
            }
          },
          (error) => {
            this.saving = false;
            this.notificationsService.showNotification("Error: " + error.message, NotificationLevel.ERROR);
          }
        );
      /*
        .pipe(
          map(() => externalId),
        );
      */
      /*
      }),
    )
    .subscribe(
      externalId => {
        this.saving = false;
        this.router.navigate(['/provision/products/search'], { queryParams: { externalId } });
      },
      error => {
        console.error(error);
        this.saving = false;
        this.notificationsService.showNotification(this.translateService.instant('PRODUCTS_KEY.saveError'), NotificationLevel.ERROR)
      }));
      */
    }
  }

  get specIdControl(): FormControl {
    return this.specIdForm.get('specId') as FormControl;
  }

  get ispControl(): FormControl {
    return this.specIdForm.get('isp') as FormControl;
  }

  get streetControl(): FormControl {
    return this.homeForm.get('street') as FormControl;
  }

  get blockControl(): FormControl {
    return this.homeForm.get('block') as FormControl;
  }

  get numberControl(): FormControl {
    return this.homeForm.get('number') as FormControl;
  }

  get homeIdControl(): FormControl {
    return this.form.get('iddomicilio') as FormControl;
  }

  get templateControl(): FormControl {
    return this.form.get('template') as FormControl;
  }

  get remoteIdControl(): FormControl {
    return this.form.get('remoteid') as FormControl;
  }

  get tvRemoteIdControl(): FormControl {
    return this.form.get('tvremoteid') as FormControl;
  }

  get ppaiControl(): FormControl {
    return this.form.get('ppai') as FormControl;
  }

  get svlanControl(): FormControl {
    return this.vlanForm.get('svlan') as FormControl;
  }

  get cvlan1Control(): FormControl {
    return this.vlanForm.get('cvlan1') as FormControl;
  }

  get cvlan2Control(): FormControl {
    return this.vlanForm.get('cvlan2') as FormControl;
  }

  get cvlan3Control(): FormControl {
    return this.vlanForm.get('cvlan3') as FormControl;
  }

  get cvlan4Control(): FormControl {
    return this.vlanForm.get('cvlan4') as FormControl;
  }

  get cvlan5Control(): FormControl {
    return this.vlanForm.get('cvlan5') as FormControl;
  }

  get avlan1Control(): FormControl {
    return this.vlanForm.get('avlan1') as FormControl;
  }

  get avlan2Control(): FormControl {
    return this.vlanForm.get('avlan2') as FormControl;
  }

  get avlan3Control(): FormControl {
    return this.vlanForm.get('avlan3') as FormControl;
  }

  get avlan4Control(): FormControl {
    return this.vlanForm.get('avlan4') as FormControl;
  }

  get avlan5Control(): FormControl {
    return this.vlanForm.get('avlan5') as FormControl;
  }
}

